<!--
// {
//   "offset": 0,
//   "seriesKey": "d40894b1-d46d-46a2-ba0b-cc055117f967",
//   "pursuitRaceTargetTime": 2700,
//   "raceNumber": 10,
//   "addedBy": "JMO5PJm63ddly4zi4XpzH59hlWq2",
//   "prep2": 60,
//   "completed": {
//       "seconds": 1746460032,
//       "nanoseconds": 678999000
//   },
//   "v": 2,
//   "prep1": 240,
//   "pursuitRaceDeltas": [],
//   "s": 12,
//   "epoch": {
//       "seconds": 1746459983,
//       "nanoseconds": 39000000
//   },
//   "seriesName": "Golden Jubilee Cup",
//   "clubId": [
//       "fxYlKWQkBHKksdC9cN4k"
//   ],
//   "name": "",
//   "scheduledTime": {
//       "seconds": 1746432000,
//       "nanoseconds": 0
//   },
//   "prestart": 60,
//   "raceState": "NotStarted",
//   "recallMode": "Hold",
//   "warn": 300,
//   "raceType": "Fleet",
//   "live": false,
//   "recallDelay": 60,
//   "started": null,
//   "starts": [
//       {
//           "name": "",
//           "prestart": 60,
//           "warn": 300,
//           "recallMode": "Hold",
//           "started": null,
//           "raceState": "NotStarted",
//           "recallDelay": 60,
//           "completed": null,
//           "offset": 0,
//           "prep2": 60,
//           "prep1": 240
//       }
//   ],
//   "id": "fe5bb6f5-0b08-40bd-8e7a-9c328e925b69",
//   "completedDt": "2025-05-05T15:47:12.678Z",
//   "state": "NotStarted"
// }
-->
<script>
import { Race } from "../../../middleware/database/race";
import { Races } from "../../../middleware/database/races";
  import { onMount, onDestroy } from 'svelte';
    let results = [];
    let urlParams = new URLSearchParams(window.location.search);
    let raceId = urlParams.get('raceId');
    let clubId = urlParams.get('clubId');
    let race = {};
    let cancelResults;
    let cancelRace;
    let timer;

    const  formatTime = (seconds)  => {
      if (seconds == 0) return '00:00.00';
      if (isNaN(seconds)) return '00:00.00';
      try {
        return new Date(seconds * 1000).toISOString().substr(11, 8);
      } catch (e) {
        console.log("invalid time", seconds);
        return '00:00.00';
      }
    }

    const inStartSequence = (raceState) => {
      return raceState === 'Five' || raceState === 'Four' || raceState === 'One' || raceState === 'Prestart'; 
    }

    const getStateText = (raceState) => {
      switch (raceState) {
      case 'NotStarted':
        return 'Waiting for start';
      case 'Prestart':
        return 'Prestart';
      case 'Five':
        return 'Sequence started';
      case 'Four':
        return 'First preparatory';
      case 'One':
        return 'Second preparatory';
      case 'ConfirmStart':
        return 'Checking for recall';
      case 'IndRecall':
        return 'Individual Recall';
      case 'InProgress':
        return 'Race in progress';
      case 'Finishing':
        return 'Race Finishing';
      case 'Finished':
        return 'Race Finished';
      default:
        return raceState;
      }
    }
   
    const updateResultColours = () => {
      let finished = race.raceState === 'Finished';
        // For index 0, 1 and 2 add a colour of gold, silver and bronze
        results.forEach((result, index) => {
          if (index == 0) result.color = finished ? '#FFD700' : ''; // Gold
          if (index == 1) result.color = finished ? '#C0C0C0' : ''; // Silver
          if (index == 2) result.color = finished ? '#CD7F32' : ''; // Bronze
        });
    }

    const processResults = (newResults) => {
      results = newResults;
      updateResultColours();
    }

    const calculateTimeSinceStart = (race) => {
      if (!race || !race.starts || race.starts.length === 0) {
        return 0;
      }
      let start = race.starts[0];
      if (!start||!race||!race.state) {
        return 0; 
      }
      let epoch = race?.epoch?.seconds;
      if (!epoch) {
        return 0;
      }
      let now = new Date().getTime() / 1000;
      let secondsSinceEpoch =  now - epoch;
      let secondsElapsed = secondsSinceEpoch - start.offset;
      let secondsInStart = start.prestart + start.warn;
      let seconds; 
      if (inStartSequence(race.state)) {
        seconds = secondsInStart - secondsElapsed;
      }else if (race.state === 'NotStarted') {
        seconds = secondsInStart;
      }else{
        seconds = secondsElapsed - secondsInStart;
      }
      return  seconds; 
    }; 


    const processRace = (newRace) => {
      race = newRace;
      updateResultColours();
      race.timeSinceStart =  formatTime(calculateTimeSinceStart(race));
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      if (race.raceState !== 'Finshed') {
        timer = setInterval(() => {
          race.timeSinceStart =  formatTime(calculateTimeSinceStart(race));
        }, 1000);
      }
    }
    
    onMount(async () => {
      race = await Races.findOne(raceId, clubId); 
      if (!race) {
        return;
      }
      
      cancelResults = await Race.subscribeResults(race.id, processResults); 
      cancelRace = await Races.subscribeOne(race.id, processRace);     

      if (!raceId) {
        // Here we are watching the latest race, so check for changes every 30 seconds
        setInterval(async () => {
          const latestRace = await Races.findOne(null, clubId);
          if (latestRace.id !== race.id) {
            cancelResults();
            cancelRace();
            race = latestRace;
            cancelResults = await Race.subscribeResults(race.id, processResults);
            cancelRace = await Races.subscribeOne(race.id, processRace);
          }
        }, 30000);
      }
    });
    onDestroy(() => {
      cancelResults();
      cancelRace();
    });
  </script>
<main>
    <div class="container">
      <div class="race-header">
        <div class="race-info">
          <h5 class="race-title">{race.seriesName} Race {race.raceNumber} {raceId?.length > 0 ? '' : ' (Latest)'}</h5>
          <div class="metadata">
            {#if race.raceState !== 'Finished'}
              <div class="race-status">
                <span class="clock">{race.timeSinceStart ?? '00:00.00'}</span>
                <span class="state">{getStateText(race.state)}</span>
              </div>
            {:else}
              <span class="state">{getStateText(race.state)}</span>
            {/if}
            {#if race.raceState === 'Finished'}
              <span class="completed">@ {race.completedDt?.toLocaleString('en-UK')}</span>
            {/if}
          </div>
        </div>
      
        <a href="results?clubId={race.clubId}" class="back-link">Back to Results</a>
      </div>
      <table class="striped responsive-table">
        <thead>
          <tr>
            {#if race.state === 'Finishing' || race.state === 'Finished'}
              <td>Pos</td>
              <td>Code</td>
            {/if}
            <td>Sail No</td>
            <td>Class</td>
            <td>Helm</td>
            <td>Crew</td>
            <td>PN</td>
            <td>Laps</td>
            <td>Elasped</td>
            <td>Corrected</td>
            <td>BCE</td>
            <td>BCR</td>
            <td>Average</td>
            <td>Best</td>
            <td>Worst</td>
          </tr>
        </thead>
        <tbody>        
          {#each results as r}
            <tr style="background-color: {r.color}">
              {#if race.state === 'Finishing' || race.state === 'Finished'}
                <td>{r.pos}</td>
                <td>{r.code}</td>
              {/if}
              <td>{r.sailNumber}</td>
              <td>{r.boatClass}</td>
              <td>{r.helm}</td>
              <td>{r.crew}</td>
              <td>{r.handicap}</td>
              <td>{r.laps.length}</td>
              <td>{r.elapsedStr}</td>
              <td>{r.correctedStr}</td>
              <td>{r.bceStr}</td>
              <td>{r.bcrStr}</td>
              <td>{r.averageStr}</td>
              <td>{r.bestLapStr}</td>
              <td>{r.worstLapStr}</td>
            </tr>
          {/each}
        </tbody>              
      </table>
      {#if !raceId}
        <div class="auto-refresh-note">
          <i class="material-icons">refresh</i>
          <span>This page automatically checks for new races every 30 seconds</span>
        </div>
      {/if}
    </div>
  </main>
<style>
  .container {
    margin-bottom: 2rem;
  }

  .race-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1rem 0 1.5rem 0;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid #e0e0e0;
  }

  .race-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .race-title {
    margin: 0;
    font-size: 1.5rem;
    color: #2c3e50;
    line-height: 1.2;
  }

  .metadata {
    display: flex;
    gap: 1.5rem;
    color: #666;
    font-size: 0.9rem;
  }

  .state, .completed {
    display: inline-flex;
    align-items: center;
  }

  .back-link {
    display: inline-flex;
    align-items: center;
    padding: 0.5rem 1rem;
    color: #1b1c1c;
    text-decoration: none;
    border-radius: 4px;
    transition: all 0.3s ease;
    font-size: 0.9rem;
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
  }

  .back-link:hover {
    background-color: #e9ecef;
  }

  @media (max-width: 600px) {
    .race-header {
      flex-direction: column;
      gap: 1rem;
    }

    .metadata {
      flex-direction: column;
      gap: 0.5rem;
    }

    .back-link {
      align-self: flex-start;
    }
  }

  .race-status {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .clock {
    display: inline-flex;
    align-items: center;
    font-family: monospace;
    font-size: 1.5rem;
    color: #2c3e50;
    font-weight: 200;
    letter-spacing: 1px;
  }

  .state {
    font-size: 0.9rem;
    color: #666;
  }

  .auto-refresh-note {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 1rem;
    padding: 0.75rem;
    background-color: #f8f9fa;
    border-radius: 4px;
    color: #666;
    font-size: 0.9rem;
  }

  .auto-refresh-note i {
    font-size: 1.2rem;
    color: #2196F3;
  }
</style>